import { TAGGING_ACTION_TYPES } from 'utils/actions/tags'

const defaultState = {
  fetching: false,
  list: [],
  error: null,
}

const { TAGGING_FAILURE, TAGGING_REQUEST, TAGGING_SUCCESS } = TAGGING_ACTION_TYPES

const tagsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case TAGGING_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: null,
      }
    }
    case TAGGING_SUCCESS: {
      return {
        ...state,
        fetching: false,
        list: action.payload.response || [],
      }
    }
    case TAGGING_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    }
    default:
      return state
  }
}

export default tagsReducer

/**
 * Selectors for tags
 */

export const selectTags = state => {
  return state.tags.list.map(tag => {
    return {
      ...tag,
      type: '@',
      description: `${tag.firstName} ${tag.lastName}`,
    }
  })
}

export const selectUserTags = state => {
  return state.tags.list
    .filter(tag => tag.type !== 'Group')
    .map(tag => {
      return {
        ...tag,
        type: '@',
        description: `${tag.firstName} ${tag.lastName}`,
      }
    })
}
export const isTagLoading = state => state.tags.fetching
